<template>
  <nxt-core-modal v-model:visible="isVisible"
                  :class="$setClasses"
                  top="0px">
    <div :class="$vClass('body')">
      <inventory :class="$vClass('body__inventory')"
                 :field="field"
                 :heightList="279"
                 :rooms="rooms"
                 isModal
                 topCustomModal="0px"></inventory>
    </div>
    <template v-slot:footer>
      <div v-if="isMobile"
           :class="$vClass('footer__text')">
        <p>
          {{ $t('inventory.furniture', { furnitureNb: furnituresNb }) }}</p>
        <p>
          {{
            $t('inventory.volume', {
              volume: $filters.format.convertToInteger(furnituresVolume, 'm³')
            })
          }}</p>
      </div>
      <div :class="$vClass('footer')">
        <nxt-core-btn :class="[$vClass('footer__cancel'),
            'nxt-button nxt-button__ghost']"
                      :title="$t('base.cancel')"
                      type="button"
                      @click="isVisible = false"></nxt-core-btn>
        <button :aria-label="$t('base.valid')"
                :class="[$vClass('footer__close'), 'nxt-button nxt-button__primary']"
                type="button"
                @click="confirmModal"
        >{{ $t('base.valid') }}
        </button>
      </div>
    </template>
  </nxt-core-modal>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { usePartnerStore } from '../../../store/partnerStore.ts';
import { useDimensionStore } from '@nextories/vue-core-components/src/store/dimensionStore.ts';
import { useFurnituresStore } from '@nextories/vue-core-components/src/store/furnituresStore.ts';

export default {
  name: 'FurnitureModal',
  nameClassStyle: 'furniture-modal',
  emits: ['visibilityChange'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    field: Object,
  },
  data() {
    return {
      rooms: [],
    };
  },
  computed: {
    ...mapState(usePartnerStore, [
      'fixedHeaderHeight',
    ]),
    ...mapState(useFurnituresStore, ['furnituresVolume', 'furnituresNb']),
    ...mapState(useDimensionStore, ['isMobile']),
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('visibilityChange', value);
      },
    },
  },
  methods: {
    ...mapActions(useFurnituresStore, [
      'setRooms',
      'setVolume',
    ]),
    updateRooms() {
      this.setRooms(this.rooms);
    },
    confirmModal() {
      this.setVolume(this.furnituresVolume);
      this.field.value = this.furnituresVolume;
      this.isVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.#{$prefixName}furniture-modal {
  :deep(.#{$prefixName}dialog__content) {
    width: auto;
    margin-bottom: 0;
    grid-template-rows: auto 1fr 105px;
    grid-auto-columns: 100%;

    @include breakpoint(mobileWithHeight) {
      padding: 12px 35px;
      grid-template-rows: auto 1fr auto;
      grid-auto-columns: 100%;
      height: 95vh;
      width: 95vw;
    }

    @include breakpoint(desktop) {
      max-width: 805px;
    }

    .#{$prefixName}custom-furniture__body__label {
      margin-top: 0;
    }

    .#{$prefixName}custom-furniture {
      .#{$prefixName}input-label {
        padding: var(--nxt-space-small) 0 var(--nxt-space-xsmall) 0;
      }

      @include breakpoint(mobileWithHeight) {
        .#{$prefixName}dialog__content {
          height: auto;
        }
        .#{$prefixName}dialog__content__header {
          position: inherit;
          padding: 12px 0 0;
        }
      }
    }
  }

  :deep(.#{$prefixName}dialog__content__header) {
    margin-bottom: 0;

    @include breakpoint(mobileWithHeight) {
      position: absolute;
      right: 0;
      padding: 12px;
      font-size: var(--nxt-font-size-large);
    }
  }

  :deep(.#{$prefixName}dialog__content__body) {
    overflow-y: hidden;
    overflow-x: hidden;

    @include breakpoint(mobileWithHeight) {
      overflow-y: hidden;
    }

    .#{$prefixName}inventory {
      &__header {

        .#{$prefixName}inline-selector__list {
          width: 100%;
          @include breakpoint(mobileWithHeight) {
            max-width: calc(805px - 60px - 320px);
          }
          @include breakpoint(tablet) {
            max-width: calc(100vw - 60px - 185px);
          }
          @include breakpoint(desktop) {
            max-width: calc(805px - 60px - 80px);
          }
        }
      }

      .#{$prefixName}furniture-selector {
        .#{$prefixName}inline-selector__list {
          @include breakpoint(mobileWithHeight) {
            max-width: calc(805px - 60px - 270px);
          }
          @include breakpoint(tablet) {
            max-width: calc(100vw - 60px - 120px);
          }
          @include breakpoint(desktop) {
            max-width: calc(805px - 60px - 80px);
          }
        }
      }
    }
  }

  :deep(.#{$prefixName}dialog__content__footer) {
    height: 100%;
    padding-top: var(--nxt-space-small);
  }

  &__body {

    &__rooms {
      margin-top: 19px;
      margin-right: var(--nxt-space-xxlarge);
    }
  }

  &__footer {
    display: grid;
    grid-template-columns: auto auto;
    grid-template-areas: "one two";
    padding-top: var(--nxt-space-small);

    @include breakpoint(mobileWithHeight) {
      height: 70px;
      padding-top: 0;
      grid-template-columns: auto 1fr auto;
      grid-template-areas: "one . two";
      row-gap: 0.7rem;
    }

    &__cancel {
      grid-area: one;
      justify-self: start;
      align-self: center;
      height: 42px;
      width: 100%;

      @include breakpoint(tablet) {
        width: 160px;
      }
    }

    &__close {
      grid-area: two;
      justify-self: end;
      align-self: center;

      @include breakpoint(tablet) {
        width: 160px;
      }

      & {
        height: 42px;
        width: 170px;
      }
    }
  }
}
</style>
